
import {
  computed, defineComponent, reactive, ref, onMounted,
} from 'vue';
import { IOption } from '@/core/models/AntDesign/IOption';
import ServicoIbsCbs from '@/servicos/Cadastros/Tributacoes/ServicoIbsCbs';
import { ICstIbsCbs } from '@/models/Entidades/Cadastros/Tributacoes/CenariosFiscais/IbsCbs/ICstIbsCbs';

export default defineComponent({
  name: 'SelecionarCstIbs',
  props: {
    cstSelecionado: {
      type: Object as () => ICstIbsCbs | null,
    },
    placeholder: {
      type: String,
      default: 'Selecione o CST',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    classCss: {
      type: String,
      default: '',
    },
  },
  emits: ['update:cstSelecionado', 'change'],
  setup(props, { emit }) {
    const refSelecionarCst = ref<HTMLElement | null>(null);

    let debounce = 0;
    const servicoIbsCbs = ServicoIbsCbs;
    let todosOsCsts: ICstIbsCbs[] = [];

    const state = reactive({
      listaCst: [] as IOption[],
      buscandoDados: false,
      emDigitacao: false,
    });

    async function pesquisarCst(valorPesquisa: string) {
      state.emDigitacao = true;
      state.buscandoDados = true;
      clearTimeout(debounce);
      debounce = setTimeout(() => {
        const listaFiltrada = !valorPesquisa
          ? todosOsCsts
          : todosOsCsts.filter((cst) => cst.codigoCst.includes(valorPesquisa) || cst.descricao.toLowerCase().includes(valorPesquisa.toLowerCase()));

        state.listaCst = listaFiltrada.map((cst) => ({
          value: cst.codigo,
          label: `${cst.codigoCst} - ${cst.descricao}`,
        }));

        state.buscandoDados = false;
      }, 300);
    }
    onMounted(async () => {
      state.buscandoDados = true;
      todosOsCsts = await servicoIbsCbs.obterIbsCbs();
      state.buscandoDados = false;
      pesquisarCst('');
    });

    const computedCodigoSelecionado = computed<number | null>({
      get: () => props.cstSelecionado?.codigo || null,
      set: (val: number | null) => {
        const cst = todosOsCsts.find((c) => c.codigo === val);
        emit('update:cstSelecionado', cst);
      },
    });

    function change() {
      emit('change', props.cstSelecionado);
    }

    function focus() {
      if (refSelecionarCst.value) {
        refSelecionarCst.value.focus();
      }
    }

    return {
      props,
      state,
      refSelecionarCst,
      pesquisarCst,
      computedCodigoSelecionado,
      change,
      focus,
    };
  },
});
